import { isValidPhone } from "./format";

export function validDeliveryAddressDraft(
  draft: {
    fullName: string;
    phone: string;
    street: string;
    building: string;
    floor: string;
    apartment: string;
  },
  deliverable: boolean,
): boolean {
  return (
    draft.fullName.trim().length > 1 &&
    isValidPhone(draft.phone) &&
    draft.street.trim().length > 1 &&
    draft.building.trim().length > 0 &&
    draft.floor.trim().length > 0 &&
    draft.apartment.trim().length > 0 &&
    deliverable
  );
}

export function validPickupTime(value: string, now = Date.now()): boolean {
  const time = new Date(value).getTime();
  return (
    Number.isFinite(time) && time > now && time <= now + 7 * 24 * 60 * 60_000
  );
}

// Only known storefront destinations may be used after changing fulfillment.
export function orderTypeReturnTo(
  value: unknown,
): "/checkout" | "/cart" | "/menu" {
  return value === "/checkout" || value === "/cart" ? value : "/menu";
}

export function orderTypeProductSlug(value: unknown): string | undefined {
  return typeof value === "string" && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value)
    ? value
    : undefined;
}
